const alphabetical = document.querySelector('.js-alphabetical')
const alphabeticalObserver = document.querySelector('.js-alphabetical-observer')
let observer;
let timeout;

if (alphabetical && alphabeticalObserver) {
  const updateObserver = () => {
    if (observer) observer.disconnect()
    observer = new IntersectionObserver(([e]) => alphabetical.classList.toggle('is-sticky', e.intersectionRatio < 1),
      {threshold: [1], rootMargin: `-${window.getComputedStyle(alphabetical).top} 0px 0px 0px`}
    );
    observer.observe(alphabeticalObserver)
  }
  updateObserver();

  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      updateObserver();
    }, 100)
  })
}
